import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay, switchMap } from 'rxjs/operators';

import { L10nService } from '@nano/core/l10n';

import { Classifier, ClassifierService, GlossaryId } from '../classifier';

@Injectable({ providedIn: 'root' })
export class PartyIdentificationGlossaryService {
  readonly personIdentificationCodeTypes$: Observable<Classifier[]>;
  readonly organizationIdentificationCodeTypes$: Observable<Classifier[]>;
  readonly beneficiaryIdentificationDocuments$: Observable<Classifier[]>;

  constructor(
    private classifierService: ClassifierService,
    private l10nService: L10nService
  ) {
    this.personIdentificationCodeTypes$ = this.l10nService.schema$.pipe(
      switchMap(() => this.classifierService.getGlossary(GlossaryId.PERSON_IDENTIFICATION_CODE_TYPE)),
      shareReplay({ bufferSize: 1, refCount: false })
    );

    this.organizationIdentificationCodeTypes$ = this.l10nService.schema$.pipe(
      switchMap(() => this.classifierService.getGlossary(GlossaryId.ORGANIZATION_IDENTIFICATION_CODE_TYPE)),
      shareReplay({ bufferSize: 1, refCount: false })
    );

    this.beneficiaryIdentificationDocuments$ = this.l10nService.schema$.pipe(
      switchMap(() => this.classifierService.getGlossary(GlossaryId.BENEFICIARY_IDENTIFICATION_DOCUMENTS)),
      shareReplay({ bufferSize: 1, refCount: false })
    );
  }
}
